<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      分销商管理
      <small>/&nbsp;角色管理</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">角色管理列表</h4>
              </div>
              <!-- end panel-heading -->

              <form
               
                style="margin-top:16px;padding-left:15px;padding-right:15px;"
              >
                <fieldset>
                  <div class="form-group row m-b-15">
                    
                     <div class="col-md-11">
                     </div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor"
                        @click="AddClick()"
                        style="float:right;"
                      >新增</a>
                    </div>
                  </div>
                </fieldset>
              </form>
              <!-- begin panel-body -->
              <div class="panel-body">
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="roleName" label="角色名称"  align="center"></el-table-column>
                  <el-table-column prop="updater" label="操作人" align="center"></el-table-column>
                  <el-table-column prop="updateTime" label="操作时间" align="center"></el-table-column>
                 <el-table-column prop="currentstatus" label="状态" align="center"></el-table-column>
                
                  <el-table-column label="操作" width="170" fixed="right" align="center">
                    <template slot-scope="scope">
                       <a
                        class="btn btn-primary btn-sm ButtonColor"
  
                        @click="BindClick(scope.row)"
                      >绑定</a>
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                       
                        @click="EditClick(scope.row)"
                      >编辑</a>
                      <a
                        class="btn btn-warning btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DeleteClick(scope.row)"
                      >删除</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
       <div v-if="EditDialog === 3" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>

        
           <el-tree :data="authList" :props="defaultProps"   default-expand-all :expand-on-click-node="false" 
           show-checkbox  @check-change="handleCheckChange" node-key="menuId" :default-checked-keys="defaultValue"
            ref="tree">
                 </el-tree>
       

        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureBind()"
              :disabled = "editdisabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
          
        </div>
      </div>
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container"> 
            <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled="deletedisabled">确定</button>
          </div>
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
         
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          style="width:95%"
        >
        
          <el-form-item label="角色名称:" prop="roleName">
            <el-input v-model="ruleForm.roleName" class="WarehouseMargin"></el-input>
          </el-form-item>
       
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = "editdisabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
          
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";

export default {
  name: "RoleManage",
  data() {
      var checkname = (rule, value, callback) => {

      setTimeout(() => {
     
        let reg = /^[0-9A-Za-z]{8,10}$/;
        if (!reg.test(value)) {
          callback(new Error("8-10位,字母或数字"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: "编辑",
      checkedRole:[],
      EditDialog: 1,
      FormData:{},
      ruledata:{},
      CurrentSelection: [],
      deletedisabled:false,
      editdisabled:false,
      defaultValue:[],
      authList: [
         ],
        defaultProps: {
          children: 'childMenus',
          label: 'menuName'
        },
      ruleForm: {
       
      },
      rules: {
        location: [{ required: true, message: "请输入库位", trigger: "blur" }, { validator: checkname, trigger: 'blur' }],
        
        roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1
    };
  },
  mounted: function() {
    this.initdata();
 
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
        this.pageindex = val;
      this.initdata();
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    handleCheckChange(data, checked, indeterminate) {   
      let arr = [];
      
         this.$refs.tree.getCheckedKeys().forEach(element =>{
           arr.push({menuId:element,roleId:this.CurrentSelection.roleId})
         })
         this.checkedRole = arr;
      
      },
     MakeSureBind(){
   
       let that = this;
       this.editdisabled = true;
      const options = {
        url: "/distribution/roles/bindUserRole",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
        
         userMenusFormsList:  that.checkedRole
        }
      };
      axios(options)
        .then(function(response) {
          that.editdisabled = false;
          that.outerVisible = false;
          if (response.data.code == 200) {
                 that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
       
          }else{
           http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
            that.editdisabled = false;
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
   
     },
    EditClick(row) {
     if(this.$refs['ruleForm']){
          this.$refs['ruleForm'].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      this.ruleForm = MethodsBus.cloneRow(row);

    },
    BindClick(item){
       this.outerVisible = true;
      this.EditDialog = 3;
       this.DialogTitle = "绑定";
      this.CurrentSelection = item;
      this.initMenus();
    },
    initMenus(){
    let arr = [];
    let that = this;
      const options = {
        url: "/distribution/roles/getRoleMenus",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          roleId: that.CurrentSelection.roleId
        
        })
      };
      axios(options)
        .then(function(response) {
         
          if (response.data.code == 200) {
           
             that.authList = response.data.data;
             response.data.data.forEach(element=>{
               if(element.checked){
                  arr.push(element.menuId)
               }
               if(element.childMenus){
                  element.childMenus.forEach(val=>{
                    if(val.checked){
                      arr.push(val.menuId)
                    }
                  })
               }
             
             })
             that.defaultValue = arr;
            

      
          }else{
           http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
        if(this.$refs['ruleForm']){
          this.$refs['ruleForm'].resetFields();
      }
      this.ruleForm = {};
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;

    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
  
    MakeSureEdit(formName) {
      let that = this;
      
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.editdisabled = true;
            const options = {
              url: "/distribution/roles/updateRole",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                roleId: this.ruleForm.roleId,
                roleName: that.ruleForm.roleName,
                systemId:3
              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.editdisabled = false;
              if(response.data.code === 200){
                   that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
              }else{
                    http.handleEorrorCode(response,that);
              }
           
            })
             .catch((error) => {
                that.editdisabled = false;
               that.outerVisible = false;
                http.handleHttpError(error, that);
                 
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.editdisabled = true;
            const options = {
              url: "/distribution/roles/addRole",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                roleName: that.ruleForm.roleName,
                systemId:3
              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.editdisabled = false;
              if(response.data.code === 200){
                that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
              }else{
                  http.handleEorrorCode(response,that);
              }
              
            })
             .catch((error) => {
                that.editdisabled = false;  
               that.outerVisible = false;
                http.handleHttpError(error, that);
               
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      that.deletedisabled = true;
      axios
        .post(
          "/distribution/roles/delRole?roleId=" +
            this.CurrentSelection.roleId +"&&systemId="+3
        )
        .then(function(response) {
          that.outerVisible = false;
           that.deletedisabled = false;
          if(response.data.code === 200){
             that.initdata();
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
          }else{
            http.handleEorrorCode(response,that);
          }
         
        })
         .catch((error) => { 
              that.outerVisible = false;
                http.handleHttpError(error, that);
                
              });
    },
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/roles/queryRolesByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          systemId:3,
          pageSize: this.pageSize,
          pageIndex: this.pageindex
        })
      };
      axios(options)
        .then(function(response) {
         
          if (response.data.code == 200) {

            that.totalCount = response.data.data.total;
            for (var i in response.data.data.records) {
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if(response.data.data.records[i].status === 1){
                response.data.data.records[i].currentstatus = '有效'
              }else if(response.data.data.records[i].status === 0){
                response.data.data.records[i].currentstatus = '无效'
              }
             
            }

            that.UserManagementList = response.data.data.records;
          }else{
           http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/RoleList.vue